export default __webpack_public_path__ + "assets/file-text-component.b81e6a3a.svg";